import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "block-list-chip mt-1" }
const _hoisted_2 = {
  key: 0,
  class: "tag"
}
const _hoisted_3 = ["onClick"]

import { useCommentsStore } from '@/stores/comments';
import { useConfirmModal } from '@/stores/confirm-modal';
import { onMounted, ref, watch } from 'vue';
import CloseIcon from './icons/navigation/CloseIcon.vue';
import VCollapseContent from './VCollapseContent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockListChips',
  props: {
    item: null,
    showItems: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { item: any, showItems?: boolean }



const commentsStore = useCommentsStore()
const confirmModal = useConfirmModal()

const deleteBlockList = (e: MouseEvent, blockList: any) => {
  confirmModal.open(e, `Are you sure you want to remove ${blockList.name} from ${props.item.name}?`, () => {
    commentsStore.removeBlockList([ props.item.id ], blockList)
  })
}

const collapseRef = ref()

watch(() => props.item.blocks.length, () => {
  collapseRef.value.update()
}, { flush: "post" })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VCollapseContent, {
    ref_key: "collapseRef",
    ref: collapseRef,
    class: "block-list-chips"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.blocks, (blockList) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (props.showItems && (blockList.items_all || blockList.items_count))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(blockList.items_all? "All": (blockList.items_count + ( blockList.items_count === 1? ' item': ' items'))), 1))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(blockList.name) + " ", 1),
          _createElementVNode("button", {
            onClick: ($event: any) => (deleteBlockList($event, blockList))
          }, [
            _createVNode(CloseIcon)
          ], 8, _hoisted_3)
        ]))
      }), 256))
    ]),
    _: 1
  }, 512))
}
}

})